import AIAgentService from '../api/AIAgentService';
import { useQuery } from '@tanstack/react-query';

export const useListUserConversations = (searchTerm?: string) =>
  useQuery({
    queryKey: ['ai-agent-conversations', searchTerm],
    queryFn: () => AIAgentService.getUserConversations(searchTerm),
  });
